export class Agent {
    Id?: number;
    Name: string;
    FirstName: string;
    MiddleName: string;
    Password: string;
    PasswordConf: string;
    createdAt: Date;
    updatedAt: Date;
    RoleId: number;
    roleName: string;
    Status: number;
    Email: string;
    PhotoURL: string;
    DateBegin: string;
    DateEnd: string;
    ChangePassword: boolean;
    isParent?: boolean;
    CategoryName: string;
    CategoryId: number;
    AgencyId: number;
    DepartmentName: string;
    ContractId?: number;
    ContractLeaderId?: number;
    Mobile?:string;
    IsBlocked:boolean;
    agent_lastname:any;
    agent_firstname:any;
    agent_middlename:any;
    category_name:any;
    sales:any;
    category_id:any;
}

export enum EventFilterDate{
    Today,
    Weekly,
    Month,
    Year
}